import React from 'react';

const BackIcon = () => {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5834 7.91666H4.48252L9.76919 2.62999C10.1917 2.20749 10.1917 1.51416 9.76919 1.09166C9.34669 0.669155 8.66419 0.669155 8.24169 1.09166L1.10252 8.23082C0.68002 8.65332 0.68002 9.33582 1.10252 9.75832L8.24169 16.8975C8.66419 17.32 9.34669 17.32 9.76919 16.8975C10.1917 16.475 10.1917 15.7925 9.76919 15.37L4.48252 10.0833H16.5834C17.1792 10.0833 17.6667 9.59582 17.6667 8.99999C17.6667 8.40415 17.1792 7.91666 16.5834 7.91666Z"/>
    </svg>
}

export default BackIcon;
